import {Component, ElementRef, Input} from '@angular/core';
import {Good, Partner} from '@app/shared';
import {getSafeImageUrl} from '@app/core';

@Component({
  selector: 'app-avatar-badge',
  standalone: false,

  templateUrl: './avatar-badge.component.html',
  styleUrl: './avatar-badge.component.less'
})
export class AvatarBadgeComponent {

  @Input() entity: any;
  @Input() urlProperty: string = 'avatar';
  @Input() labelProperties: string[] = ['name', 'surName'];
  @Input() isCurrency = false;

  constructor(public el: ElementRef) {
  }

  protected readonly getSafeImageUrl = getSafeImageUrl;
}
